import DateTimeDisplay from '../../components/DateTimeDisplay'
import EntityListTemplate from '../../templates/EntityListTemplate'
import { Link } from '@mui/material'
import { getGridStringOperators } from '@mui/x-data-grid'

const DevicesPage = () => {
  const handleLinkClick = (event) => {
    event.stopPropagation()
  }

  const stringOperators = getGridStringOperators().filter(
    (operator) =>
      operator.value === 'contains' ||
      operator.value === 'equals' ||
      operator.value === 'startsWith',
  )

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      type: 'string',
      sortable: true,
      filterable: true,
      filterOperators: stringOperators,
      width: 200,
      flex: 1,
    },
    {
      field: 'common_name',
      headerName: 'Common Name',
      type: 'string',
      sortable: true,
      filterable: true,
      filterOperators: stringOperators,
      width: 200,
      flex: 1,
    },
    {
      field: 'ip',
      headerName: 'IP',
      type: 'string',
      sortable: false,
      filterable: true,
      filterOperators: stringOperators,
      width: 180,
      flex: 1,
      valueGetter: (value) => value || 'N/A',
    },
    {
      field: 'organization',
      headerName: 'Organization',
      type: 'string',
      sortable: true,
      filterable: true,
      disableColumnMenu: false,
      filterOperators: stringOperators,
      width: 160,
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <Link
            href={`/organizations/${params.value.uuid}`}
            onClick={handleLinkClick}
          >
            {params.value.name}
          </Link>
        ) : (
          'N/A'
        ),
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      type: 'string',
      sortable: true,
      filterable: false,
      width: 200,
      flex: 1,
      renderCell: (row) => (
        <DateTimeDisplay date={new Date(row.value)} showTime={true} />
      ),
    },
  ]

  return (
    <EntityListTemplate
      entityName="devices"
      columns={columns}
      title="Device List"
      defaultSort={[{ field: 'createdAt', sort: 'desc' }]}
      defaultFilters={{ items: [] }}
    />
  )
}

export default DevicesPage
